import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { trackEvent } from "@/lib/tracking";

// Phone-only sticky CTA: shows after the hero, hides once the target form (and footer) is reached.
export default function MobileStickyCta({ label, targetId, heroId, service, className }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const hero = document.getElementById(heroId)?.getBoundingClientRect();
      const form = document.getElementById(targetId)?.getBoundingClientRect();
      const pastHero = hero ? hero.bottom < 0 : window.scrollY > 600;
      const formStillBelow = form ? form.top > window.innerHeight : true;
      setShow(pastHero && formStillBelow);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [heroId, targetId]);

  return (
    <div
      aria-hidden={!show}
      className={`lg:hidden fixed inset-x-0 bottom-0 z-40 px-4 pb-[calc(env(safe-area-inset-bottom)+12px)] pt-3 bg-gradient-to-t from-black/25 to-transparent transition-[opacity,transform] duration-300 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full pointer-events-none"
      }`}
    >
      <a
        href={`#${targetId}`}
        tabIndex={show ? 0 : -1}
        data-testid="mobile-sticky-cta"
        onClick={() => trackEvent("cta_click", { location: "mobile_sticky", service })}
        className={`flex items-center justify-center gap-1.5 h-12 rounded-full font-bold shadow-[0_10px_30px_-10px_rgba(0,0,0,0.5)] ${className}`}
      >
        {label} <ArrowRight className="h-5 w-5" />
      </a>
    </div>
  );
}
